import {AbstractModel} from '../abstract-model';
import {TranslationDomainLocale} from './translation-domain-locale';

export class TranslationDomain extends AbstractModel {
  id: number | null = null;
  domain: string = '';
  description: string = '';
  baseLocale: string | null = null;
  locales: TranslationDomainLocale[] = [];

  private toLocales: TranslationDomainLocale[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.locales) {
      this.locales = input.locales.map((locale: any) => new TranslationDomainLocale().deserialize(locale));
    }

    this.toLocales = this.locales.filter((locale: TranslationDomainLocale) => locale.locale !== this.baseLocale);
    this.toLocales.sort((a: TranslationDomainLocale, b: TranslationDomainLocale): number => {
      if (a.locale && b.locale) {
        return a.locale?.localeCompare(b.locale) ?? 0;
      }

      return 0;
    });

    return this;
  }

  getBaseToLocale(): TranslationDomainLocale | null {
    return this.locales.find((locale: TranslationDomainLocale) => locale.locale === this.baseLocale) ?? null;
  }

  getToLocales(): TranslationDomainLocale[] {
    return this.toLocales;
  }
}
